import React, { useState } from "react";
import { Button, Grid } from "@mui/material";
//import { ErrorText } from "..";

export const TraitsInput = ({ onSave, onCancel, isError, errorText, Traits = null }) => {
    const [traits, setTraits] = useState(Traits === null ? [{ traitName: "", traitValue: "" }] : Traits);

    const handleTraitChange = (index, field, value) => {
        const updatedTraits = traits.map((trait, i) => 
            i === index ? { ...trait, [field]: value } : trait
        );
        setTraits(updatedTraits);
    };

    const handleAddTrait = () => {
        setTraits([...traits, { traitName: "", traitValue: "" }]);
    };

    const handleRemoveTrait = (index) => {
        const updatedTraits = traits.filter((_, i) => i !== index);
        setTraits(updatedTraits);
    };

    const handleSave = () => {
        onSave(traits);  // Pass traits back to parent component
    };

    const handleCancel = () => {
        setTraits([{ traitName: "", traitValue: "" }]);  // Reset form
        onCancel();  // Call the cancel function in parent
    };

    return (
        <div className="" style={{padding:'10px', display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center'}}>

            <div style={{marginTop:'10px'}}>
            <h3>Enter Memorabilia Traits</h3>
            </div>
            <Grid container  style={{ maxHeight: '100%', overflowY: 'auto', width: '100%' }}>
            {traits.map((trait, index) => (
                <Grid item>
                    <div style={{marginTop:'10px'}} key={index} >
                        <input
                            style={{margin:'5px'}}
                            type="text"
                            placeholder="Trait Name"
                            value={trait.traitName}
                            onChange={(e) => handleTraitChange(index, "traitName", e.target.value)}
                            className={isError ? 'errorTextInput' : 'textInputCls'}
                        />
                        <input
                            style={{margin:'5px'}}
                            type="text"
                            placeholder="Trait Value"
                            value={trait.traitValue}
                            onChange={(e) => handleTraitChange(index, "traitValue", e.target.value)}
                            className={isError ? 'errorTextInput' : 'textInputCls'}
                        />
                        {traits.length > 1 && (
                            
                            <Button style={{margin:'5px'}} variant="contained" sx={{ background: "#E3031F" }} onClick={() => handleRemoveTrait(index)}>
                            Remove
                            </Button>
                        )}
                    </div>
                </Grid> 
            ))}
            </Grid>
            <Button style={{margin:'5px', marginTop:'10px'}} variant="contained" sx={{ background: "#458059" }} onClick={handleAddTrait}>
            Add Another Trait
            </Button>
            {/* {isError && <ErrorText text={errorText} />} */}

            <div style={{marginTop:'10px'}} >
            
            <Button  style={{margin:'5px'}} variant="contained" sx={{ background: "black" }} onClick={handleCancel}>
            Cancel
            </Button>
            <Button style={{margin:'5px'}} variant="contained" sx={{ background: "#4E9D24" }} onClick={handleSave}>
            Save
            </Button>
                
            </div>
            
        </div>
    );
};

export default TraitsInput;
